<div class="tw:relative">
  <ion-searchbar
    color="light"
    placeholder="Address/City/State/Zip"
    (ionClear)="searchBarClear()"
    (ionInput)="searchBarChange($event)"
    [value]="searchText$ | async"
    search-icon="/assets/svg/property-search-active.svg"
    [ngClass]="{ 'search-bar-expanded': searchBarExpanded }"
  ></ion-searchbar>
  @if (showMoreButton) {
    <ion-button class="tw:absolute tw:top-2 tw:right-2" fill="clear" (click)="toggleSearchBarMenu()">
      <ion-icon slot="icon-only" name="ellipsis-vertical-outline"></ion-icon>
    </ion-button>
  }
</div>
